"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateUserProfileAction } from "@/resources/actions/user.actions";
import { queryKeys } from "@/lib/query-keys";

export interface UpdateProfileData {
  first_name: string;
  last_name: string;
}

/**
 * Update profile mutation hook
 * Handles user profile updates with cache invalidation
 */
export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateProfileData) => {
      const result = await updateUserProfileAction({
        first_name: data.first_name,
        last_name: data.last_name,
      });

      if (result.error) {
        throw new Error(result.error);
      }

      return result.data;
    },
    onSuccess: () => {
      // Invalidate profile query to refetch updated data
      queryClient.invalidateQueries({
        queryKey: queryKeys.auth.userProfile(),
      });
    },
    onError: (error: Error) => {
      console.error("Update profile error:", error);
    },
  });
}
